<script setup lang="ts">
import { useSharedState } from 'composables/useSharedState';

useSharedState<{}>({});
</script>

<template>
  <div class="e-accordion-header">
    <slot />
  </div>
</template>
